import type { GetTweets200PageAllOfThreeContentItemAuth } from './getTweets200PageAllOfThreeContentItemAuth';
import type { GetTweets200PageAllOfThreeContentItemAuthor } from './getTweets200PageAllOfThreeContentItemAuthor';
import type { GetTweets200PageAllOfThreeContentItemBasicInfo } from './getTweets200PageAllOfThreeContentItemBasicInfo';
import type { GetTweets200PageAllOfThreeContentItemEngagement } from './getTweets200PageAllOfThreeContentItemEngagement';
import type { GetTweets200PageAllOfThreeContentItemMedia } from './getTweets200PageAllOfThreeContentItemMedia';
import type { GetTweets200PageAllOfThreeContentItemPoll } from './getTweets200PageAllOfThreeContentItemPoll';
import type { GetTweets200PageAllOfThreeContentItemReferencedTweet } from './getTweets200PageAllOfThreeContentItemReferencedTweet';
import type { GetTweets200PageAllOfThreeContentItemTags } from './getTweets200PageAllOfThreeContentItemTags';
import type { GetTweets200PageAllOfThreeContentItemUserInteraction } from './getTweets200PageAllOfThreeContentItemUserInteraction';

export type GetTweets200PageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: GetTweets200PageAllOfThreeContentItemAuth;
  /** 트윗 작성자 정보 */
  author?: GetTweets200PageAllOfThreeContentItemAuthor;
  basicInfo?: GetTweets200PageAllOfThreeContentItemBasicInfo;
  engagement?: GetTweets200PageAllOfThreeContentItemEngagement;
  /** 미디어 정보 */
  media?: GetTweets200PageAllOfThreeContentItemMedia;
  /** 트윗에 포함될 투표 정보 (선택 사항) */
  poll?: GetTweets200PageAllOfThreeContentItemPoll;
  /** 참조된 트윗 정보 (답글, 인용, 리트윗인 경우) */
  referencedTweet?: GetTweets200PageAllOfThreeContentItemReferencedTweet;
  /** 트윗 태그 정보 */
  tags?: GetTweets200PageAllOfThreeContentItemTags;
  /** 사용자 상호작용 정보 */
  userInteraction?: GetTweets200PageAllOfThreeContentItemUserInteraction;
};
